module.exports = __webpack_public_path__ + "static/media/traffic-roadworks.9ccfeaa8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/traffic-roadworks.svg
// module id = 763
// module chunks = 0